export default __webpack_public_path__ + "static/media/studentModalLiveCourse.568b4808.svg";